






























import { Component, Vue } from "vue-property-decorator";
import "@/assets/svg-file/bottom_info/best_quality.svg";
import "@/assets/svg-file/bottom_info/instant_delivery.svg";
import "@/assets/svg-file/bottom_info/persistent_support.svg";
import contactUs from "@/jsbridge/service/contact_us";
import { isIos } from "@/utils/lodash";
import { Getter } from "vuex-class";
import * as setting_types from "@/store/constants/setting_types";
@Component({
  components: {}
})
export default class BottomInfo extends Vue {
  @Getter(setting_types.GETTER_CONTACT_EMAIL)
  private contactEmail: any;

  get isIOS() {
    return isIos();
  }

  private clickContact() {
    contactUs();
  }
  private goToFaq() {
    this.$router.push({
      name: "Faqs",
      params: {
        routerTransition: "up"
      }
    });
  }

  private mounted() {
    // this.contactToUs();
  }
}
